// src/util/toastManager.ts
import { toast, Id, TypeOptions } from "react-toastify"; // Importar TypeOptions também

// Mapeia IDs para toasts ativos, para evitar duplicatas
const activeToasts: { [key: string]: Id | null } = {};

export const showManagedToast = (
    // Corrigido para 'warning' em vez de 'warn' no tipo de parâmetro
    type: "success" | "error" | "info" | "warning",
    message: string,
    toastIdKey: string // Uma chave única para este tipo de mensagem (ex: 'dna-validation-error')
) => {
    // Se já existe um toast ativo para esta chave, atualiza ele em vez de criar um novo
    if (activeToasts[toastIdKey]) {
        toast.update(activeToasts[toastIdKey]!, {
            render: message,
            // Certifique-se de que o 'type' passado para update seja um TypeOptions válido
            type: type as TypeOptions, // Adicionar um type assertion aqui pode ajudar o TS
            autoClose: 5000,
            closeButton: true,
        });
    } else {
        // Cria um novo toast e armazena sua ID
        // Aqui, as funções diretas (toast.success, toast.error, etc.) aceitam 'warn' ou 'warning'
        // mas é mais consistente usar 'warning' em toda parte para evitar o problema de tipagem
        activeToasts[toastIdKey] = toast[type](message, { // 'type' aqui será 'warning'
            autoClose: 5000,
            closeButton: true,
            onClose: () => {
                activeToasts[toastIdKey] = null; // Limpa a referência quando o toast fecha
            },
        });
    }
};

// Opcional: Função para fechar um toast específico se necessário
export const dismissManagedToast = (toastIdKey: string) => {
    if (activeToasts[toastIdKey]) {
        toast.dismiss(activeToasts[toastIdKey]!);
        activeToasts[toastIdKey] = null;
    }
};